<template>
    <div class="main-container">
        <div class="tier-header">
            <img
                v-if="getUserlevel.userlevel === 'gold'"
                class="home-banner"
                src="@/assets/profile/home_tier_gold_new_theme.svg"
                alt=""
            />
            <img
                v-else-if="getUserlevel.userlevel === 'silver'"
                class="home-banner"
                src="@/assets/profile/home_tier_silver_new_theme.svg"
                alt=""
            />
            <img
                v-else
                class="home-banner"
                src="@/assets/profile/home_tier_bronze_new_theme.svg"
                alt=""
            />
            <div class="benefit-btn" @click="gotopage('/benefit')">
                <span> ดูสิทธิประโยชน์ </span>
                <span class="arrow-image">
                    <img src="@/assets/profile/arrow_white.svg" alt="" />
                </span>
            </div>
        </div>
        <div class="profile-container">
            <div class="greeting-container center">
                <div v-if="dayTime === 'afternoon'" class="greeting-text">
                    Good Afternoon,
                </div>
                <div v-else-if="dayTime === 'evening'" class="greeting-text">
                    Good Evening,
                </div>
                <div v-else-if="dayTime === 'night'" class="greeting-text">
                    Good Night,
                </div>
                <div v-else class="greeting-text">Good Morning,</div>
                <div class="profile-name">
                    {{ profile.FirstName }}
                </div>
            </div>
            <div class="wrapper_profile_point">
                <div>
                    คุณมี
                    <span class="value-coin"
                        >{{
                            profile.updated_points
                                ? numberWithCommas(
                                      profile.updated_points.points
                                  )
                                : ""
                        }}
                        คะแนน
                    </span>
                    <img
                        class="ic"
                        src="../../../assets/icon/icon_points.svg"
                        alt=""
                    />
                </div>
                <div class="wrapper-qr" @click="showQRCode()">
                    <span>
                        รับคะแนน
                        <img
                            class="ic_qr"
                            src="../../../assets/icon/qr_header.svg"
                            alt=""
                        />
                    </span>
                </div>
            </div>
            <ModalMaster :controller="modalController"></ModalMaster>
        </div>
    </div>
</template>

<script>
import moment from "moment";
//service
import BzbsApi from "@/core/Account/service/BzbsProfile.js";
import CacheHelper from "@/helper/CacheHelper.js";
// mixins
import ModalMixin from "@/mixin/ModalMixin";
//vuex
import { mapGetters } from "vuex";

export default {
    name: "newprofile",
    mixins: [ModalMixin],
    data: function () {
        return {
            cacheHelper: new CacheHelper(),
            profile: {},
            line_image: null,
            dayTime: "morning",
        };
    },
    beforeDestroy() {
        clearInterval(this.runClockSerialInterval);
    },
    created: function () {
        this.setTimeText();
        this.line_image = this.cacheHelper.getCache("BzbsUser").line.pictureUrl;
        this.getProfile();
        this.initialRedeemModal();
    },
    computed: mapGetters(["getUserlevel"]),
    methods: {
        setTimeText() {
            let today = parseInt(moment().format("HHmm"));
            if (today <= 600) {
                return (this.dayTime = "night");
            } else if (today <= 1200) {
                return (this.dayTime = "morning");
            } else if (today <= 1800) {
                return (this.dayTime = "afternoon");
            } else {
                return (this.dayTime = "night");
            }
        },
        getProfile() {
            BzbsApi.getProfile(
                this.cacheHelper.getCache("BzbsUser").token
            ).then((response) => {
                this.profile = response.data;
                this.QrModal.setProfile(this.profile);
            });
        },
        numberWithCommas(x) {
            if (x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else if (x == 0) {
                return 0;
            } else {
                return "-";
            }
        },
        showQRCode() {
            this.QrModal.show();
        },
        gotopage(path) {
            this.$router.push(path);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/module/List/style/profile.scss";
</style>
